namespace $.$$ {

	$mol_style_define($bog_formigo_ai, {

		padding: $mol_gap.block,
		gap: '1rem',

		Title: {
			font: {
				size: '1.1rem',
				weight: 'bold',
			},
		},

		Docs: {
			Item: {
				height: '3rem',
			},
			Add: {
				height: '3rem',
			},
		},

		Results: {
			background: {
				color: $mol_theme.card,
			},
			border: {
				radius: $mol_gap.round,
			},
			padding: $mol_gap.block,
		},

	})

}
